import {gql} from '@apollo/client';
import {PopReviewFiltersTypeInput} from './getPopReviewPageList';

/** POP 审核计数（与列表同筛选条件）；用于 Tab 角标等仅需数字的场景 */
export const GET_POP_REVIEW_COUNT = gql`
    query GetPopReviewCount($filters: PopReviewFiltersTypeInput) {
        getPopReviewCount(filters: $filters)
    }
`;

export interface GetPopReviewCountResponse {
    getPopReviewCount: number;
}

export interface GetPopReviewCountInput {
    filters?: PopReviewFiltersTypeInput;
}
